import { S3Client } from "@aws-sdk/client-s3";

// AWS S3 Configuration
const s3Client = new S3Client({
  region: process.env.REACT_APP_AWS_REGION,
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  },
});

export { s3Client };
export const BUCKET_NAME = process.env.REACT_APP_S3_BUCKET_NAME;
